(function () {
    const handleFAQclick = (event) => {
        event.preventDefault();
        const { dataset } = event.target;
        const { assetid } = dataset;
        const { faqname } = dataset;
        console.log(assetid);
        console.log(faqname);
        const builtURL = `${
            document.location.origin + document.location.pathname
        }?query=${assetid}`;
        document.location = builtURL;
    };

    const initFAQcards = () => {
        const allFAQlinks = document.querySelectorAll(
            '.related-cards__link-faq'
        );
        allFAQlinks.forEach((item) => {
            item.addEventListener('click', handleFAQclick);
        });
    };

    initFAQcards();
})();
